import { useEffect, useState } from 'react';
import CameraTile from '../components/CameraTile';
import EventTicker from '../components/EventTicker';
import { listCameras, type Camera } from '../lib/api';

export default function Grid() {
  const [cameras, setCameras] = useState<Camera[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    listCameras()
      .then(setCameras)
      .catch((e) => setErr(String(e)));
  }, []);

  return (
    <main style={{
      maxWidth: 1440,
      margin: '0 auto',
      padding: 'clamp(1rem, 3vw, 2.5rem)',
    }}>
      {/* header */}
      <header style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: '2rem',
        flexWrap: 'wrap',
        marginBottom: '2rem',
        paddingBottom: '1.5rem',
        borderBottom: '1px solid var(--grid-line)',
      }}>
        <div>
          <div className="eyebrow" style={{ marginBottom: 8 }}>
            <span className="dot dot-pulse" style={{ background: 'var(--orange)' }} />tv.compoundrx · live
          </div>
          <h1 className="headline" style={{ fontSize: 'clamp(28px, 4vw, 48px)' }}>
            Floor operations<br/>in real time.
          </h1>
        </div>
        <div className="mono" style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'right', lineHeight: 1.7 }}>
          <div>■ all cameras privacy-filtered</div>
          <div>■ audio stripped at edge</div>
          <div>■ 60s rolling window · no scrub-back</div>
        </div>
      </header>

      {err && (
        <div className="mono" style={{ color: 'var(--orange)', padding: '1rem', fontSize: 12 }}>
          ▸ {err}
        </div>
      )}

      {/* camera grid */}
      <section style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
        gap: '1.25rem',
      }}>
        {cameras === null && !err && (
          <div className="mono" style={{ color: 'var(--muted)', padding: '1rem' }}>
            ▸ loading cameras…
          </div>
        )}
        {cameras?.map((cam) => <CameraTile key={cam.id} camera={cam} />)}
      </section>

      {/* event ticker */}
      <section style={{ marginTop: '3rem' }}>
        <EventTicker />
      </section>

      <footer className="mono" style={{
        marginTop: '4rem',
        paddingTop: '1.5rem',
        borderTop: '1px solid var(--grid-line)',
        fontSize: 10,
        color: 'var(--muted)',
        letterSpacing: '0.1em',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '1rem',
      }}>
        <div>■ compoundrx · live operations</div>
        <div>session expires 24h · all views audited</div>
      </footer>
    </main>
  );
}
